import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.cssForIcon(_ctx.node.attributes)),
    style: _normalizeStyle(_ctx.styleForIcon(_ctx.node.attributes))
  }, [
    (_ctx.node.attributes['ui:icon:name'])
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(_ctx.glyphiconForName(_ctx.node.attributes['ui:icon:name']))
        }, null, 2))
      : _createCommentVNode("", true),
    (!_ctx.node.attributes['ui:icon:name'])
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(_ctx.iconCss)
        }, null, 2))
      : _createCommentVNode("", true)
  ], 6))
}